import clsx from 'clsx';
import * as R from 'ramda';

import { gwrrSchema } from '@atom/constants/customReportSchemaConstants';

import ElementAssessmentRow from './ElementAssessmentRow';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  elements?: any;
}

const ChildAssessmentTable = ({ elements }: Props) => {
  const containsSpecificAttributes = (attributeIds: string[]) => {
    return elements.reduce((acc, element) => {
      const hasAttributes = R.keys(element.attributes).reduce(
        (innerAcc, attributeId) => {
          return attributeIds.includes(String(attributeId)) || innerAcc;
        },
        false,
      );

      return hasAttributes || acc;
    }, false);
  };

  const specificAttributeIds = R.values(
    R.pick(['boredAtId', 'shellId', 'voidId'], gwrrSchema.poolAttributes),
  );

  const showColumns = containsSpecificAttributes(specificAttributeIds);

  const schemaIds = R.values(
    showColumns
      ? gwrrSchema.poolAttributes
      : R.omit(['boredAtId', 'shellId', 'voidId'], gwrrSchema.poolAttributes),
  );

  return (
    <>
      <div>
        <table>
          <thead>
            <tr className={classes.tableHeader}>
              <th className={classes.tableHeaderCell}>Element</th>
              <th className={classes.tableHeaderCell}>Condition Rating</th>
              {showColumns && (
                <>
                  <th className={classes.tableHeaderCell}>Bored At</th>
                  <th className={classes.tableHeaderCell}>Shell</th>
                  <th className={classes.tableHeaderCell}>Void</th>
                </>
              )}
              <th className={clsx(classes.tableHeaderCell, classes.comment)}>
                Comment
              </th>
              <th className={classes.tableHeaderCell}>Repair Recommendation</th>
              <th className={classes.tableHeaderCell}>Priority</th>
              <th className={classes.tableHeaderCell}>Assessment Flag</th>
            </tr>
          </thead>
          <tbody>
            {elements.map(element => (
              <ElementAssessmentRow
                key={element.id}
                element={element}
                schemaIds={schemaIds}
              />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ChildAssessmentTable;
